export enum EStatusLoteFuncionarioEnum {
  CRIADO = "Criado",
  EM_VALIDACAO = "Processando", // Lote em processamento
  ABERTO = "Em aberto", // Lote validado, cadastrado e aberto para revisão
  AGENDADO = "Agendado", // nao usado por enquanto
  EM_EXECUCAO = "Em execução", // nao usado por enquanto
  AGUARDANDO_PROCESSAMENTO = "Processando", // usuário conferiu e solicitou os cartões
  EM_PROCESSAMENTO = "Processando",
  PROCESSADO_COM_FALHA = "Erro importação", // Lote com erro em todos os itens na importação pós processamento dos itens
  FINALIZADO = "Finalizado",
  CANCELADO = "Cancelado",
  ERRO = "Erro planilha", // Lote com erro em todos os itens na importação
}

const CommonStatusMap = {
  emAberto: { label: "Em aberto", color: "#333333" },
  processando: { label: "Processando", color: "#EEB03D" },
  cancelado: { label: "Cancelado", color: "#757474" },
  erroPlanilha: { label: "Erro planilha", color: "#DC3645" },
  erroImportacao: { label: "Erro importação", color: "#DC3645" },
};

export const StatusLoteFuncionarioMap = {
  ["CRIADO"]: CommonStatusMap.emAberto,
  ["ABERTO"]: CommonStatusMap.emAberto,
  ["EM_VALIDACAO"]: CommonStatusMap.processando,
  ["EM_EXECUCAO"]: CommonStatusMap.processando,
  ["EM_PROCESSAMENTO"]: CommonStatusMap.processando,
  ["AGUARDANDO_PROCESSAMENTO"]: CommonStatusMap.processando,
  ["PROCESSADO_COM_FALHA"]: CommonStatusMap.erroImportacao,
  ["AGENDADO"]: { label: "Agendado", color: "#3772FF" },
  ["FINALIZADO"]: { label: "Finalizado", color: "#05A660" },
  ["CANCELADO"]: CommonStatusMap.cancelado,
  ["ERRO"]: CommonStatusMap.erroPlanilha,
};
